<template>
      <el-dialog
            :visible.sync="visible"
            append-to-body
            :show-close="true"
            :center="true"
            :before-close="handleClose"
            title="选择岗位"
        >
        <div>
            <el-tabs tab-position="left" style="height: 500px;">

                  <el-tab-pane 
                    v-for="(item,index) in classList" 
                    :key="item.value"
                    :index="index+1+''" 
                    :label="item.label">

                    <div class="category">
                        <span v-for=" (item2,index) in item.children"  
                        :key="item2.value" 
                        @click="selectCategory(item2)"
                         :class="{'active': item2.checked==true}">
                            {{item2.label}} 
                        </span>
                    </div>
                    </el-tab-pane>
                </el-tabs>
          
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submit">确定</el-button>
            <el-button @click="visible = false">取 消</el-button>
        </span>
     </el-dialog>   
</template>


<script>
import { getClassTree} from "@/api/director/job/index.js";

export default {
    data() {
        
        return {
            visible: false,
            defaultActive:'1',
            classList:[],
            selectedList:[],
         
        }
           
    },


    methods: {
        handleClose() {
            this.visible = false;
        },


        init(selectedList) {
            this.visible = true;
            if(selectedList!=null&&selectedList.length>0&&selectedList!=''){
                this.selectedList=selectedList;
            }
            
            this.initClassList();
        },


        //
        initClassList(){
            var that = this;
            getClassTree({}).then((response) => {
                console.log(response);
                if(response.code==200){
                    that.classList = response.data;
                    that.initCheckedStatus();
                }
                
               
            });
        },

        initCheckedStatus(){
            if(this.selectedList==null||this.selectedList.length<=0){
                return;
            }

            for (let cate of this.classList) {
                for (let item2 of cate.children ) {

                    for (let selected of this.selectedList ) {
                        if(item2.value==selected.value){
                           item2.checked=true;
                        }
                    }

                }
            }
        },

      

        submit(){
            var that=this;
            that.selectedList=[];
            for (let cate of that.classList) {
                for (let item2 of cate.children ) {
                    if(item2.checked){
                        that.selectedList.push(item2);
                    }
                }
            }

            if(this.selectedList==null||this.selectedList.length<=0){
                this.$message.warning("请选择职位类别");
                return;
            }else{
                this.$emit('setClassItems',this.selectedList);
                this.visible = false;
            }
        },

        selectCategory(item){
            var that=this;
            item.checked=item.checked?false:true;
            that.$forceUpdate();
        }
       
       
    }
}
</script>
<style lang="scss" scoped>
  .el-header {
    background-color: #B3C0D1;
    color: #333;
    line-height: 60px;
  }
  
  .el-aside {
    color: #333;
  }

  .category{
    flex-flow: wrap;
    height: 500px;
    span{
        padding: 10px;
    margin: 5px;
    line-height: 40px;
    word-wrap: break-all;
    word-break: normal;
    cursor: pointer;

        &.active{
            background: #4c71db;
            color: #ffffff;
        }
    }
  }
</style>
